import styled, { css } from 'styled-components';
import media from '../../../../constants/media';
import { StyledRadio } from '../formikRadio';

export const Wrapper = styled.div`
	position: relative;
	border: 1px solid ${({ theme }) => theme.colors.borderColor};
	border-radius: 3px;
	transition: box-shadow 150ms, border-color 150ms;
	margin-bottom: 2rem;

	input[type='radio'] {
		display: none;
	}

	&:last-child {
		margin-bottom: 0;
	}

	&:hover {
		${StyledRadio}:after {
			opacity: 1;
		}
	}

	&:focus {
		border: 1px solid ${({ theme }) => theme.colors.grayLigh};
	}

	${({ checked }) =>
		checked &&
		css`
			border-color: ${({ theme }) => theme.colors.secondary};
			box-shadow: 0px 14px 24px rgba(0, 0, 0, 0.1);
			svg {
				path:first-child {
					fill: ${({ theme }) => theme.colors.secondary};
					stroke-width: 0;
				}
				path {
					tstroke: ${({ theme }) => theme.colors.secondary};
				}
				line {
					stroke: ${({ theme }) => theme.colors.secondary};
				}
			}
			&:focus {
				border: 1px solid ${({ theme }) => theme.colors.secondaryDark};
			}
		`};
`;

export const StyledDescription = styled.div`
	padding: 0 4rem;

	${media.tablet`
        padding: 0 8rem;
    `};
`;

export const RadioTileLabel = styled.label`
	display: block;
	padding: 4rem 2rem;
	cursor: pointer;
	${media.tablet`
		padding: 4rem 4rem;
	`}
	${({ compact }) =>
		compact &&
		`
			padding: 1rem 2rem !IMPORTANT;
	`}
`;

export const TileRadio = styled(StyledRadio)`
	display: none;
`;

export const Top = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const TopLeft = styled.div`
	display: flex;
	align-items: center;
`;

export const IconWrapper = styled.div`
	svg {
		width: 4.5rem;
		height: 4.5rem;
		padding-top: 0.8rem;
		path {
			fill: ${({ theme }) => theme.colors.grayLighter3};
		}
	}
`;

export const LabelText = styled.div`
	font-size: 2rem;
	color: ${({ theme }) => theme.colors.black};
	padding-left: 2rem;
`;

export const LabelWrapper = styled.div`
	display: flex;
	flex-direction: column;
`;

export const EstTime = styled.div`
	font-size: 1.4rem;
	padding-left: 2rem;
`;

export const PriceWrapper = styled.div`
	text-align: right;
`;

export const PriceLabel = styled.div`
	font-size: 1.4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	color: ${({ theme }) => theme.colors.black};
`;

export const PriceValue = styled.div`
	font-size: 3rem;
	font-family: ${({ theme }) => theme.fonts.ArimoMedium};
	line-height: 1;
	color: ${({ theme }) => theme.colors.primary};
`;

export const ChildWrapper = styled.div`
	padding: 0 4rem 2.5rem 4rem;

	${media.tablet`
        padding: 0 8rem 3.5rem 8rem;
    `};
`;
